// extracted by mini-css-extract-plugin
export default {"top-button":"top-button--EJ7yg"};